// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__3D_Fc","cell-content":"Cell_cell-content__3tngt","bold":"Cell_bold__T18Kh","right":"Cell_right__2dTDF"};